export const COPILOT_THEME_IMAGE_URL = "assets/mail/themes/copilot/image.jpg";
export const COPILOT_THEME_CACHE_NAME = "copilot_theme";
export const COPILOT_THEME_IMAGE_CACHE_KEY = "/copilotthemeimage.jpg";
export const COPILOT_THEME_TIMESTAMP_HEADER = "X-Timestamp";
export const COPILOT_THEME_TIMESTAMP_QUERY_PARAM = "timestamp";
